import React from 'react';
import { Box, Link, Text } from '@nerdwallet/currency';

import styles from './wp-edit-link.module.less';

interface Props {
  id: string;
}

const WpEditLink: React.FC<Props> = ({ id }) => {
  if (!id) {
    return null;
  }

  return (
    <Box className={styles['wp-edit-link']}>
      <Text size="small">
        <Link
          href={`/blog/wp-admin/post.php?post=${id}&action=edit`}
          target="new"
        >
          Edit Article
        </Link>
      </Text>
    </Box>
  );
};

export default WpEditLink;
